import { struct } from 'io-ts/Decoder';

import { Id } from './Id';
import { ParentId } from './ParentId';

/**
 * Composite DynamoDB key for a team record: `(id, erId)` — `id` is the parent
 * id, `erId` the prefixed team id. Carried on the v2 source-pipeline backfill
 * SQS payload so the populate handler can hit `byKeys` (BatchGetItem) directly
 * without a GSI lookup.
 */
export const ComplexId = struct({
	id: ParentId,
	erId: Id,
});
